<template>
	<div class="mianPage flex_start">
		<div class="leftBoxCard">
			<div class="cardTitle">个人信息</div>
			<div class="cardContent flex_center">
				<div class="cardContImg">
					<img src="../../assets/icon/user.png" alt="" />
				</div>
			</div>
			<div class="cardContent space_between">
				<div class="cardContTxt"><i class="el-icon-s-custom"></i>用户名称</div>
				<div class="cardContTxt" v-if="userFormData.nickName">{{userFormData.nickName}}</div>
				<div class="cardContTxt" v-else>-</div>
			</div>
			<div class="cardContent space_between">
				<div class="cardContTxt"><i class="el-icon-mobile-phone"></i>手机号码</div>
				<div class="cardContTxt" v-if="userFormData.phone">{{userFormData.phone}}</div>
				<div class="cardContTxt" v-else>-</div>
			</div>
			<div class="cardContent space_between">
				<div class="cardContTxt"><i class="el-icon-message"></i>用户邮箱</div>
				<div class="cardContTxt" v-if="userFormData.email">{{userFormData.email}}</div>
				<div class="cardContTxt" v-else>-</div>
			</div>
			<div class="cardContent space_between">
				<div class="cardContTxt"><i class="el-icon-s-data"></i>所属部门</div>
				<div class="cardContTxt">-</div>
			</div>
			<div class="cardContent space_between">
				<div class="cardContTxt"><i class="el-icon-user-solid"></i>所属角色</div>
				<div class="cardContTxt" v-if="roles">{{roles}}</div>
				<div class="cardContTxt" v-else>-</div>
			</div>
			<div class="cardContent space_between">
				<div class="cardContTxt"><i class="el-icon-date"></i>创建日期</div>
				<div class="cardContTxt">{{userFormData.createdTime}}</div>
			</div>
		</div>
		<div class="rightBoxCard">
			<div class="cardTitle">基本资料</div>
			<div class="rightBoxCont">
				<el-tabs v-model="activeTab">
				  <el-tab-pane label="基本资料" name="userinfo">
				    <el-form inline class="el-form el_dialog_form" label-width="120px" :rules="userRulesApi"
				    :model="userFormData" ref="ruleUserForm">
				    	<el-form-item label="用户昵称：" prop="nickName">
				    		<el-input clearable size="small" v-model="userFormData.nickName" placeholder="请输入"></el-input>
				    	</el-form-item>
				    	<el-form-item label="手机号码：" prop="phone">
				    		<el-input clearable size="small" v-model="userFormData.phone" placeholder="请输入"></el-input>
				    	</el-form-item>
				    	<el-form-item label="邮箱：">
				    		<el-input clearable size="small" v-model="userFormData.email" placeholder="请输入"></el-input>
				    	</el-form-item>
							<el-form-item label="邮寄地址：">
								<el-input clearable size="small" v-model="userFormData.mailAddress" placeholder="请输入"></el-input>
							</el-form-item>
				    	<el-form-item label="性别：">
				    		<el-radio v-model="userFormData.sex" :label="1">男</el-radio>
				    		<el-radio v-model="userFormData.sex" :label="2">女</el-radio>
				    	</el-form-item>
				    	<div class="card-bottom flex_start">
				    		<!-- <el-button @click="closeMediaDialog" size="medium">取消</el-button> -->
				    		<el-button type="primary" @click="confirmUser('ruleUserForm')" size="medium">保存</el-button>
				    	</div>
				    </el-form>
				  </el-tab-pane>
				  <!-- <el-tab-pane label="修改密码" name="resetPwd">
				    <el-form inline class="el-form el_dialog_form" label-width="120px" :rules="pwdRulesApi"
				    :model="pwdFormData" ref="rulePwdForm">
				    	<el-form-item label="旧密码：" prop="appName">
				    		<el-input clearable type="passward" size="small" placeholder="请输入"></el-input>
				    	</el-form-item>
				    	<el-form-item label="新密码：" prop="companyName">
				    		<el-input clearable type="passward" size="small" placeholder="请输入"></el-input>
				    	</el-form-item>
				    	<el-form-item label="确认新密码：">
				    		<el-input clearable type="passward" size="small" placeholder="请输入"></el-input>
				    	</el-form-item>
				    	<div class="card-bottom flex_start">
				    		<el-button type="primary" @click="confirmPwd('rulePwdForm')" size="medium">保存</el-button>
				    	</div>
				    </el-form>
				  </el-tab-pane> -->
				</el-tabs>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeTab: "userinfo",
				userRulesApi: {
					nickName: [{required: true,message: '请输入用户昵称',trigger: 'blur'},],
				},
				userFormData: {
					sex: 1
				},
				pwdRulesApi: {},
				pwdFormData: {},
				roles: ''
			}
		},
		mounted() {
			// this.getTableData();
			if(sessionStorage.getItem('sdk-roles')){
				this.roles = JSON.parse(sessionStorage.getItem('sdk-roles')).join(',');
			}
			this.getUserInfo();
		},
		methods: {
			// 获取个人信息
			async getUserInfo(){
				let data = {}
				let res = await this.$http.get(this.$api.adminUser,data);
				if (res.code == 1) {
					this.userFormData = res.data
				}
			},
			confirmUser(formName){
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.userFormData;
						let res = await this.$http.post(this.$api.adminUserEdit, data);
						if(res.code == 1){
							this.$message.success('编辑成功');
						}
					}
				});
			},
			confirmPwd(){
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.pwdFormData;
						let res = await this.$http.post(this.$api.adminUserEdit, data);
						this.$message.success('编辑成功');
						this.closeMediaDialog();
						this.getTableData();
					}
				});
			}
		}
	}
</script>

<style scoped>
	.mianPage {
		margin: 20px;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 24px;
	}
	.leftBoxCard{
		width: 300px;
		box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
		border-radius: 4px;
		flex-shrink: 0;
	}
	.cardTitle{
		padding: 12px 15px;
		font-size: 16px;
		border-bottom: 1px solid #efefef;
	}
	.cardContent{
		font-size: 14px;
		padding: 12px 15px;
		border-bottom: 1px solid #efefef;
	}
	.cardContTxt i{
		margin-right: 4px;
	}
	.cardContImg{
		padding: 20px;
	}
	.cardContImg img{
		
	}
	.rightBoxCard{
		margin-left: 20px;
		flex: 1;
		box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
		border-radius: 4px;
	}
	.rightBoxCont{
		padding: 15px;
	}
	.card-bottom{
		padding-left: 120px;
	}
</style>